import React from 'react';
import { Modal, Header, Image } from 'semantic-ui-react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { closeRecipeModal } from '../../actions/recipeModal';
import Ingridient from './Ingridient';

const RecipeModal = React.memo(({ isOpenRecipeModal, closeRecipeModal, modalRecipeData }) => {
  if (!modalRecipeData) return null;
  const {
    name = '',
    text = '',
    products = [],
    calories,
    carbohydrates,
    fats,
    proteins,
    tags,
    image,
  } = modalRecipeData;

  return (
    <Modal open={isOpenRecipeModal} closeIcon onClose={closeRecipeModal} size="large">
      <Modal.Header>{name}</Modal.Header>
      <Modal.Content image={!!image}>
        {image && <Image size="medium" src={image} wrapped />}
        <WrapModalText>
          <WrapTextRecipe>{text}</WrapTextRecipe>
          <WrapRecipeInfo>
            <WrapRecipeSubinfo>
              <Header>Ингредиенты на 100г. блюда:</Header>
              {products &&
                products.map((ingredient) => (
                  <Ingridient key={ingredient.id} ingridient={ingredient} />
                ))}
            </WrapRecipeSubinfo>
            <WrapRecipeSubinfo>
              <Header>Теги:</Header>
              {tags &&
                tags.map((tag) => (
                  <RecipeListItemInfoWrap key={tag.tag_id + tag.name}>
                    {tag.name}
                  </RecipeListItemInfoWrap>
                ))}
            </WrapRecipeSubinfo>
            <WrapRecipeSubinfo>
              <Header>КБЖУ на 100 г.</Header>
              <RecipeListItemInfoWrap>Kалории = {calories}</RecipeListItemInfoWrap>
              <RecipeListItemInfoWrap>Белки = {proteins}</RecipeListItemInfoWrap>
              <RecipeListItemInfoWrap>Жиры = {fats}</RecipeListItemInfoWrap>
              <RecipeListItemInfoWrap>Углеводы = {carbohydrates}</RecipeListItemInfoWrap>
            </WrapRecipeSubinfo>
          </WrapRecipeInfo>
        </WrapModalText>
      </Modal.Content>
    </Modal>
  );
});

const mapStateToProps = (state) => ({
  isOpenRecipeModal: state.reducers.isOpenRecipeModal,
  modalRecipeData: state.reducers.modalRecipeData,
  measures: state.dishSearch.measures,
});

const mapDispatchToProps = (dispatch) => ({
  closeRecipeModal: () => dispatch(closeRecipeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecipeModal);

const WrapRecipeInfo = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const WrapRecipeSubinfo = styled.div`
  max-width: 250px;
  min-width: 150px;
`;

const WrapTextRecipe = styled.div`
  white-space: break-spaces;
`;

const WrapModalText = styled.div`
  width: 100%;
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const RecipeListItemInfoWrap = styled.div`
  margin: 3px 0px;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/RecipeModal.jsx